import { LeadStatus } from 'types/leads';
import { Dictionary } from 'utils/constants/dictionary';

export const getLeadStatusKey = (status: LeadStatus): string => {
	switch (status) {
		case LeadStatus.CONTACTED : return Dictionary.leads.status.contacted;
		case LeadStatus.IN_NEGOTIATIONS : return Dictionary.leads.status.inNegotiations;
		case LeadStatus.LINK_SENT : return Dictionary.leads.status.linkSent;
		case LeadStatus.LOST : return Dictionary.leads.status.lost;
		case LeadStatus.NEW_LEAD : return Dictionary.leads.status.newLead;
		case LeadStatus.POSTPONED : return Dictionary.leads.status.postponed;
		case LeadStatus.SOLD : return Dictionary.leads.status.sold;
		default: return 'default-id';
	}
};
